import { Component, OnInit, ViewChild } from '@angular/core';
import { TokenStorageService } from '../../../auth/services/token-storage.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { read, utils } from "xlsx"
import Swal from 'sweetalert2';
import { UserService } from '../../../auth/services/user.service';
import { compconfService } from '../../services/compconf.service';
import { User } from '../../../auth/models/user.model';
import { Compconf } from '../../models/compconf.model';
import { CommunService } from '../../../../shared/services/commun';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { dataService } from '../../../../shared/services/data.service';
import { datacommService } from '../../../../shared/services/datacomm.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-insert-compconf-file',
  templateUrl: './insert-compconf-file.component.html',
  styleUrls: ['./insert-compconf-file.component.scss']
})
export class InsertCompconfFileComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport, {static: false})
  public viewPort: CdkVirtualScrollViewport;
  displayStyle: string;
  settedfiltreditems: any[]=[];
  displaysearch='none';
  jsondata2: any[]=[];
  jsondata3: any[]=[];
  jsondata4: any[]=[];
  file2: any;
  uploadEvent2: any;
  displaysearch2: string;
  file3: any;
  uploadEvent3: any;
  displaysearch3: string;
  file4: any;
  uploadEvent4: any;
  displaysearch4: string;
  currentItemsToShow2: any=[];
  currentItemsToShow3: any=[];
  currentItemsToShow4: any=[];
  exceljsondata6: any[]=[];
  exceljsondata7: any[]=[];

  public get inverseOfTranslation(): string {
    if (!this.viewPort || !this.viewPort["_renderedContentOffset"]) {
      return "-0px";
    }
    let offset = this.viewPort["_renderedContentOffset"];
    return `-${offset}px`;
  }
  currentUser: User;
  loading=false;
 file: any;
 uploadEvent: any;
 arrayBuffer: string | ArrayBuffer;
 compconfsSub: Subscription;
 Compconf: Compconf;
  compconfform: FormGroup;
  jsondata: any=[];
  currentItemsToShow= [];
  optionValue:any
  filtreditems=[];
 constructor(private token: TokenStorageService,private compconfservice: compconfService,private userservice: UserService,
  private formBuilder: FormBuilder,private commun: CommunService,private data: dataService,private datacomm: datacommService,
   private router: Router,) {}
  ngOnInit() {
    this.currentUser = this.token.getUser();
    
  }
  myFunction1() {
    var checkbox:any = document.getElementById("myCheck1");
    var checkbox2:any = document.getElementById("myCheck2");
    var checkbox3:any = document.getElementById("myCheck3");
    var checkbox4:any = document.getElementById("myCheck4");

    var text2 = document.getElementById("bodycontainer1");
    if (checkbox.checked == true){
      text2.style.display = "block";
     // checkbox2.style.display="none"
     // checkbox3.style.display="none"
    //  checkbox4.style.display="none"

    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de compconfs, voulez vous continuer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) { 
          this.jsondata=[]
          text2.style.display = "none";
          checkbox2.style.display="block"
          checkbox3.style.display="block"
          checkbox4.style.display="block"
        }
        else{
          checkbox.checked = true
          text2.style.display = "block";
          checkbox2.style.display="none"
          checkbox3.style.display="none"
          checkbox4.style.display="none"
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
  }
}
  myFunction2() {
    var checkbox2:any = document.getElementById("myCheck2");
    var checkbox:any = document.getElementById("myCheck1");
    var checkbox3:any = document.getElementById("myCheck3");
    var checkbox4:any = document.getElementById("myCheck4");
    var text3 = document.getElementById("bodycontainer2");
      if (checkbox2.checked == true){
        text3.style.display = "block";
        checkbox3.style.display="none"
        checkbox.style.display="none"
        checkbox4.style.display="none"
      } else {
        Swal.fire({
          title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de work gab, voulez vous continuer?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Réinitialiser',
          cancelButtonText: 'Annuler',
        }).then((result) => {
          if (result.value) { 
            this.jsondata2=[]
            text3.style.display = "none";
            checkbox3.style.display="block"
            checkbox.style.display="block"
            checkbox4.style.display="block"
          }
          else{
            checkbox2.checked = true
            text3.style.display = "block";
            checkbox3.style.display="none"
            checkbox.style.display="none"
            checkbox4.style.display="none"
          }
        }).catch(() => {
          Swal.fire('opération non aboutie!');
        });
      }
    }
  myFunction3() {
   
    var checkbox3:any = document.getElementById("myCheck3");
    var checkbox2:any = document.getElementById("myCheck2");
    var checkbox:any = document.getElementById("myCheck1");
    var checkbox4:any = document.getElementById("myCheck4");
    var text4 = document.getElementById("bodycontainer3");
    if (checkbox3.checked == true){
      text4.style.display = "block";
      checkbox.style.display="none"
      checkbox2.style.display="none"
      checkbox4.style.display="none"
    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de work pos, voulez vous continuer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) { 
          this.jsondata3=[]
          text4.style.display = "none";
          checkbox.style.display="block"
          checkbox2.style.display="block"
          checkbox4.style.display="block"
        }
        else{
          checkbox3.checked = true
          text4.style.display = "block";
          checkbox.style.display="none"
          checkbox2.style.display="none"
          checkbox4.style.display="none"
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
    }
  }
  myFunction4() {
   
    var checkbox4:any = document.getElementById("myCheck4");
    var checkbox2:any = document.getElementById("myCheck2");
    var checkbox3:any = document.getElementById("myCheck3");
    var checkbox:any = document.getElementById("myCheck1");
    var text5 = document.getElementById("bodycontainer4");
    if (checkbox4.checked == true){
      text5.style.display = "block";
      checkbox.style.display="none"
      checkbox2.style.display="none"
      checkbox3.style.display="none"
    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de work sms, voulez vous continuer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) { 
          this.jsondata4=[]
          text5.style.display = "none";
          checkbox.style.display="block"
          checkbox2.style.display="block"
          checkbox3.style.display="block"
        }
        else{
          checkbox4.checked = true
          text5.style.display = "block";
          checkbox.style.display="none"
          checkbox2.style.display="none"
          checkbox3.style.display="none"
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
    }
  }
  myFunction5() {
    var checkbox:any = document.getElementById("myCheck5");
    var text2 = document.getElementById("bodycontainer5");
    if (checkbox.checked == true){
      text2.style.display = "block";
    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de données, voulez vous continuer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) { 
          text2.style.display = "none";
        }
        else{
          checkbox.checked = true
          text2.style.display = "block";
  
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
    }
  }
  myFunction6() {
    var checkbox:any = document.getElementById("myCheck6");
    var text2 = document.getElementById("bodycontainer6");
    if (checkbox.checked == true){
      text2.style.display = "block";
    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout de données commercant, voulez vous continuer?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) { 
          text2.style.display = "none";
        }
        else{
          checkbox.checked = true
          text2.style.display = "block";
  
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
    }
  }

  onFileChange2(event: any) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      const fileName = this.file.name;
      const fileExtension = fileName.split('.').pop()?.toLowerCase();
      if (fileExtension === 'txt') {
        this.processTextFile(this.file);
      } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
        this.processExcelFile(this.file);
      } else {
        console.error('Unsupported file type. Please upload a .txt or .xlsx file.');
      }
    }
  }
  
// Method to process TXT files
processTextFile(file: File) {
  const fileReader = new FileReader();
  const arr: any[] = [];
  
  fileReader.onload = (e) => {
    //@ts-ignore
    const guestList = fileReader.result.split(/\r?\n/);
    for (let i = 0; i < guestList.length; ++i) {
      if (guestList[i].substring(95, 100) !== guestList[i].substring(100, 123)) {
        arr.push({
          doctype: 'compconf',
          MERCHANTIDENTIFICATION: guestList[i].substring(0, 10),
          BATCHIDENTIFICATION: guestList[i].substring(10, 16),
          INVOICENUMBER: guestList[i].substring(16, 22),
          CARDHOLDERNUMBER: guestList[i].substring(22, 41),
          MERCHANTSECTOR: guestList[i].substring(41, 42),
          CHANNELTRANSACTIONID: guestList[i].substring(42, 43),
          OPERATIONCODE: guestList[i].substring(43, 44),
          TRANSACTIONCODE: guestList[i].substring(44, 46),
          TRANSACTIONAMOUNT: guestList[i].substring(46, 55),
          CARDEXPIRYDATE: guestList[i].substring(55, 59),
          PROCESSINGDATE: new Date('20' + guestList[i].substring(59, 65).substring(4, 6) + '-' + guestList[i].substring(59, 65).substring(2, 4) + '-' + guestList[i].substring(59, 65).substring(0, 2)),
          TRANSACTIONDATE: new Date('20' + guestList[i].substring(65, 71).substring(4, 6) + '-' + guestList[i].substring(65, 71).substring(2, 4) + '-' + guestList[i].substring(65, 71).substring(0, 2)),
          AUTHORIZATIONCODE: guestList[i].substring(71, 77),
          REMITTANCEDATE: guestList[i].substring(77, 83),
          MERCHANTCATEGORIECODE: guestList[i].substring(83, 87),
          FILLER: guestList[i].substring(87, 89),
          ACQUIRERBANKIDENTIFICATION: guestList[i].substring(89, 94),
          LOCALCARDSYSTEMNETWORK: guestList[i].substring(94, 95),
          ISSUERBANKIDENTIFICATION: guestList[i].substring(95, 100),
          ACQUIRERREFERENCENUMBER: guestList[i].substring(100, 123),
          TRANSACTIONORDERUSAGECODE: guestList[i].substring(123, 125),
          CHARGEBACKREASONCODE: guestList[i].substring(125, 127),
          CHARGEBACKTRANSACTIONCYCLE: guestList[i].substring(127, 128),
          MESSAGE: guestList[i].substring(128, 150),
          ndPRESENTMENTREASONCODE: guestList[i].substring(125, 127),
          ndPRESENTMENTTRANSACTIONCYCLE: guestList[i].substring(127, 128),
          PRESENTMENTINDICATOR: guestList[i].substring(163, 164),
          MERCHANTNAME: guestList[i].substring(125, 150),
          SETTLEMENTAMOUNT: guestList[i].substring(150, 159),
          TRANSACTIONTIME: guestList[i].substring(159, 163),
          FILLER2: guestList[i].substring(163, 167),
          ENDOFRECORD: guestList[i].substring(167, 168),
        });
      }
    }
    this.jsondata = arr;
    console.log(this.jsondata);
    this.buildData(this.jsondata.length);
    this.displaysearch = "block";
  };

  fileReader.readAsText(file);
}
// Method to process Excel files
processExcelFile(file: File) {
  const fileReader = new FileReader();
  const arr: any[] = [];

  fileReader.onload = (e: any) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Use header: 1 to get rows as arrays
    jsonData.forEach((row: any, index: number) => {
      if (index === 0) return; // Skip header row if present
      if (row[18] !== row[19]) { // Comparing values by column order
        arr.push({
          doctype: 'compconf',
          MERCHANTIDENTIFICATION: row[0] || '',
          BATCHIDENTIFICATION: row[1] || '',
          INVOICENUMBER: row[2] || '',
          CARDHOLDERNUMBER: row[3]+'   ' || '',
          MERCHANTSECTOR: row[4] || '',
          CHANNELTRANSACTIONID: row[5] || '',
          OPERATIONCODE: row[6] || '',
          TRANSACTIONCODE: row[7] || '',
          TRANSACTIONAMOUNT: row[8] || '',
          CARDEXPIRYDATE: row[9] || '',
          PROCESSINGDATE: new Date('20' + row[10].toString().substring(4, 6) + '-' + row[10].toString().substring(2, 4) + '-' + row[10].toString().substring(0, 2)),
          TRANSACTIONDATE: new Date('20' + row[11].toString().substring(4, 6) + '-' + row[11].toString().substring(2, 4) + '-' + row[11].toString().substring(0, 2)),
          AUTHORIZATIONCODE: row[12] || '',
          REMITTANCEDATE: row[13] || '',
          MERCHANTCATEGORIECODE: row[14] || '',
          FILLER: row[15] || '',
          ACQUIRERBANKIDENTIFICATION: row[16] || '',
          LOCALCARDSYSTEMNETWORK: row[17] || '',
          ISSUERBANKIDENTIFICATION: row[18] || '',
          ACQUIRERREFERENCENUMBER: row[19] || '',
          TRANSACTIONORDERUSAGECODE: row[20] || '',
          CHARGEBACKREASONCODE: row[21] || '',
          CHARGEBACKTRANSACTIONCYCLE: row[22] || '',
          MESSAGE: row[23] || '',
          ndPRESENTMENTREASONCODE: row[24] || '',
          ndPRESENTMENTTRANSACTIONCYCLE: row[25] || '',
          PRESENTMENTINDICATOR: row[26] || '',
          MERCHANTNAME: row[27] || '',
          SETTLEMENTAMOUNT: row[28] || '',
          TRANSACTIONTIME: row[29] || '',
          FILLER2: row[30] || '',
          ENDOFRECORD: row[31] || '',
        });
      }
    });

    this.jsondata = arr;
    console.log(this.jsondata);
    this.buildData(this.jsondata.length);
    this.displaysearch = "block";
  };

  fileReader.readAsArrayBuffer(file);
}
  save()

  {
    this.loading = true;
    console.log(this.jsondata)
    if(this.jsondata.length>0)
    {
      this.compconfservice.createcompconf(this.jsondata).then(
        (data:any) => {
          this.loading = false;
    console.log(this.jsondata)        
    Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'fichiers ajoutées avec succès!',
            showConfirmButton: false,
            timer: 6000 
          });
              this.reloadPage();
        },
        (error) => {
          this.loading = false;
          
        }
      );
    }
  }

buildData(length: number) {
  const ITEMS_RENDERED_AT_ONCE = 5000;
  const INTERVAL_IN_MS = 1000;

  let currentIndex = 0;

  const interval = setInterval(() => {
    const nextIndex = currentIndex + ITEMS_RENDERED_AT_ONCE;
    for (let n = currentIndex; n <= nextIndex ; n++) 
    {
      if (n >= length) {
        clearInterval(interval);
        break;
      }
      if(this.jsondata.length>0)
      {
        this.currentItemsToShow.push(
          this.jsondata[n]
        )
      }
      if(this.jsondata2.length>0)
      {
        this.currentItemsToShow2.push(
          this.jsondata2[n]
        )
      }
      if(this.jsondata3.length>0)
      {
        this.currentItemsToShow3.push(
          this.jsondata3[n]
        )
      }
      if(this.jsondata4.length>0)
      {
        this.currentItemsToShow4.push(
          this.jsondata4[n]
        )
      }
    }
    currentIndex += ITEMS_RENDERED_AT_ONCE;
  }, INTERVAL_IN_MS)
}
/*onPageChange($event) {
  this.currentItemsToShow =  this.jsondata.slice($event.pageIndex*$event.pageSize, $event.pageIndex*$event.pageSize + $event.pageSize);
}
filtercompconf()
{
  this.displayStyle = "block";
  this.filtreditems.push(
    this.commun.findByValue2(this.currentItemsToShow,this.optionValue)
  )
  this.settedfiltreditems= this.filtreditems.filter((obj, index) => {
    return index === this.filtreditems.findIndex(o => obj === o);
  });}
closePopup()
{
  this.displayStyle = "none";
 
}*/
reloadPage(): void {
  
  setTimeout(() => window.location.reload(), 3000);
  
}
}